export default __webpack_public_path__ + "img/f0489173144f8dd0ef55556153987688.png";